import { useState, useEffect, useCallback, useRef } from 'react';
import { Editor } from 'slate';

export function useTagTextDeleteWarning(editor: Editor) {
  const [showWarning, setShowWarning] = useState(false);
  const dismissedTagIds = useRef(new Set<string>());
  const activeTagId = useRef<string | null>(null);

  useEffect(() => {
    (editor as any).__onTagTextDeleted = (tagId: string) => {
      if (dismissedTagIds.current.has(tagId)) return;
      activeTagId.current = tagId;
      setShowWarning(true);
    };
    return () => {
      (editor as any).__onTagTextDeleted = undefined;
    };
  }, [editor]);

  const handleConfirm = useCallback(() => {
    if (activeTagId.current) {
      dismissedTagIds.current.add(activeTagId.current);
    }
    activeTagId.current = null;
    setShowWarning(false);
  }, []);

  const handleRevert = useCallback(() => {
    activeTagId.current = null;
    editor.undo();
    setShowWarning(false);
  }, [editor]);

  return { showWarning, handleConfirm, handleRevert };
}
